import { render, staticRenderFns } from "./ApiVersionView.vue?vue&type=template&id=c8902472&scoped=true"
import script from "./ApiVersionView.vue?vue&type=script&lang=js"
export * from "./ApiVersionView.vue?vue&type=script&lang=js"
import style0 from "./ApiVersionView.vue?vue&type=style&index=0&id=c8902472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8902472",
  null
  
)

export default component.exports